export default "__VITE_ASSET__97c45868__"